import actionTypes from '../actionTypes';

const initialState = {};

const ZoomDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ZOOM_SDK_DETAILS:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export default ZoomDetailsReducer;
